import { Navbar, NavbarGroup } from '@blueprintjs/core';
import * as React from 'react';
import SubNavMenuItem from 'src/components/layout/SubNavMenuItem';
// import Project from 'src/models/Project';
// import UserDetails from 'src/models/UserDetails';
import '../../../ProjectNavBar.scss';

interface IPMNavBarProps {
    location: string;
    matchUrl: string;
    // user: UserDetails;
    // currentProject: Project;
    navigate: (path: string) => void;
}

const PMNavBar = (props: IPMNavBarProps) => {
    const subNavProps = {
        location: props.location,
        navigate: props.navigate,
        section: 'processing',
    };

    console.log('Props?', props);

    // const showNav = (nav: JSX.Element, roles: UserRoles[], user: UserDetails, tabName: string = null) => {
    //     let hasRole = false;
    //     roles.forEach((role) => {
    //         hasRole = hasRole || Authorization.IsInRole(role, user);
    //     });
        
    //     return hasRole || Authorization.IsStaffed(tabName, props.currentProject?.id, user) ? nav : undefined;
    // };

    return (
        <Navbar className="project-nav-bar">
            <NavbarGroup>
                <SubNavMenuItem name="Lease Records" path={`${props.matchUrl}/`} {...subNavProps} />
                <SubNavMenuItem name="Assignments" path={`${props.matchUrl}/assignments`} {...subNavProps} />
                <SubNavMenuItem name="Transmittals" path={`${props.matchUrl}/transmittals`} {...subNavProps} />
            </NavbarGroup>
        </Navbar>
    );
};

export default PMNavBar;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ProcessingAndMaintenance/PMNavBar.tsx